import TriangleIcon from './TriangleIcon'

export default TriangleIcon
